import React from "react";
import PublicNavbar from "../../components/PublicNavbar";
import Footer from "../../components/Footer";

export default function LegalPrivacy() {
  return (
    <div className="min-h-screen bg-white">
      <PublicNavbar />
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-16">
        <div className="overline">RGPD</div>
        <h1 className="font-heading text-3xl sm:text-4xl font-medium tracking-tight text-slate-900 mt-2">
          Politique de confidentialité
        </h1>
        <div className="text-xs text-slate-500 mt-1">Dernière mise à jour : 17 février 2026</div>

        <div className="mt-10 text-[15px] leading-relaxed text-slate-700 space-y-8">
          <Section title="1. Responsable du traitement">
            <p>
              Le responsable du traitement des données collectées sur la plateforme Junago est{" "}
              <strong>Junago SAS</strong>, 42 rue de la Mobilité, 75002 Paris, France.
              Contact délégué à la protection des données :{" "}
              <a className="text-violet-600 underline" href="mailto:dpo@junago.fr">dpo@junago.fr</a>.
            </p>
          </Section>

          <Section title="2. Données collectées">
            <p>Junago collecte uniquement les données nécessaires au fonctionnement de la plateforme :</p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Loueurs</strong> : email, mot de passe chiffré (bcrypt), nom, société, téléphone, informations Stripe Connect.</li>
              <li><strong>Clients</strong> : nom, email, téléphone lors d'une réservation.</li>
              <li><strong>Véhicules</strong> : photos, description, plaque d'immatriculation, tarif, ville.</li>
              <li><strong>Réservations</strong> : dates, véhicule, montant, statut.</li>
              <li><strong>Données techniques</strong> : adresse IP, type de navigateur, logs d'accès (conservés 12 mois).</li>
            </ul>
          </Section>

          <Section title="3. Finalités">
            <p>Ces données sont utilisées pour :</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Créer et gérer les comptes loueurs (authentification, sécurité).</li>
              <li>Traiter les réservations et les paiements.</li>
              <li>Communiquer avec les utilisateurs (confirmations, notifications).</li>
              <li>Améliorer la plateforme (statistiques agrégées et anonymisées).</li>
              <li>Respecter nos obligations légales et fiscales.</li>
            </ul>
          </Section>

          <Section title="4. Base légale">
            <p>
              Les traitements reposent sur l'exécution du contrat (réservation, gestion de compte),
              le consentement (communications marketing) et l'intérêt légitime (sécurité, prévention
              de la fraude).
            </p>
          </Section>

          <Section title="5. Destinataires">
            <p>Vos données peuvent être partagées avec :</p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Stripe</strong> pour le traitement des paiements.</li>
              <li>Le <strong>loueur concerné</strong> lors d'une réservation (coordonnées client).</li>
              <li>Les autorités compétentes en cas d'obligation légale.</li>
            </ul>
            <p>Aucune donnée n'est revendue à des tiers.</p>
          </Section>

          <Section title="6. Durée de conservation">
            <ul className="list-disc pl-5 space-y-1">
              <li>Compte loueur : durée de vie du compte + 3 ans après inactivité.</li>
              <li>Réservations / factures : 10 ans (obligation comptable).</li>
              <li>Logs techniques : 12 mois maximum.</li>
            </ul>
          </Section>

          <Section title="7. Vos droits">
            <p>Conformément au RGPD, vous disposez à tout moment d'un droit :</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>d'accès, de rectification, d'effacement ;</li>
              <li>de limitation et d'opposition au traitement ;</li>
              <li>à la portabilité de vos données ;</li>
              <li>de retirer votre consentement à tout moment.</li>
            </ul>
            <p>
              Pour exercer ces droits, contactez{" "}
              <a className="text-violet-600 underline" href="mailto:dpo@junago.fr">dpo@junago.fr</a>.
              Vous pouvez également introduire une réclamation auprès de la{" "}
              <a className="text-violet-600 underline" href="https://www.cnil.fr" target="_blank" rel="noreferrer">CNIL</a>.
            </p>
          </Section>

          <Section title="8. Cookies">
            <p>
              Junago utilise uniquement des cookies techniques indispensables (session,
              préférences). Aucun cookie publicitaire ou de tracking tiers n'est déposé sans
              votre consentement explicite.
            </p>
          </Section>

          <Section title="9. Sécurité">
            <p>
              Les mots de passe sont chiffrés (bcrypt). Les paiements sont délégués à Stripe
              (PCI DSS niveau 1). Les communications sont chiffrées en HTTPS (TLS 1.3).
            </p>
          </Section>
        </div>
      </div>
      <Footer />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-heading text-xl font-medium tracking-tight text-slate-900">{title}</h2>
      <div className="mt-3 space-y-3">{children}</div>
    </section>
  );
}
